import React from 'react';
import { Main } from './components';

const MaterialAlmacen: React.FC = () => {
  return <Main />;
};

export default MaterialAlmacen;
